import { render } from "./DeltaBadge.vue?vue&type=template&id=d0a97958"
import script from "./DeltaBadge.vue?vue&type=script&lang=js"
export * from "./DeltaBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__